<template>
    <div class="vh-100">
        <!-- HEADER -->
        <div class="header-top bg-white">
            <div class="header-top--inner w-limit d-flex justify-content-between align-items-center">
                <div class="header-top--left">
                    <div class="header-item" data-toggle="modal" data-target="#myModalclose">
                        <div class="icon-24 icon-x-blue"></div>
                    </div>
                </div>
                <div class="header-top--middle f-cont f-16 f-bold">Daftar</div>
                <div class="header-top--right">
                    <div class="header-item"></div>
                </div>
            </div>
        </div>

        <main class="content-wrapper main-page flex-100">
            <div class="p-y-16 p-x-20 w-limit flex-1">
                <div class="badge-tag tg-blue f-14">Langkah <b>3 / 3</b></div>
                <div class="f-16 m-t-16">Silahkan isi <b>nama, kota domisili & email</b> anda saat ini.</div>
                <form class="" action="">
                    <div class="form-group mod">
                        <label for="input-1" class="form-label m-t-16 require">Nama (Pemilik Usaha)</label>
                        <InputRegular
                            v-model="nama"
                            :type="'text'"
                            :id="'input-1'"
                            :placeholder="'Budi'"
                            :validationType="'alphanumeric'"
                            :classes="'form-control'"
                            ref="inputregular_nama"
                        />
                        <!--<small id="alertPemilikUsaha" class="form-text text-muted alertLabel"></small>-->
                        <ErrorMessage class="error" label="Nama (Pemilik Usaha)" :validation="$v.nama"></ErrorMessage>
                    </div>

                    <div class="mod m-t-16">
                        <label class="form-label require" for="Kota">Kota Domisili</label>
                        <Select2
                            class="test-select fl-is-required"
                            id="select2"
                            v-model="selectedkota"
                            :options="optionskota"
                            :settings="{ placeholder: 'Pilih Kota' }"
                            @change="myChangeEvent($event)"
                        />
                        <!--<small id="alertKota" class="form-text text-muted alertLabel"></small>-->
                        <ErrorMessage class="error" label="Kota Domisili" :validation="$v.selectedkota"></ErrorMessage>
                    </div>

                    <div class="form-group mod">
                        <label class="form-label m-t-16" for="input-3">Email (Optional)</label>
                        <!--<input class="form-control inputs" type="email" id="input-3" v-model="email" placeholder="sutiajimumpung@gmail.com"/>-->
                        <InputRegular
                            v-model="email"
                            :type="'email'"
                            :id="'input-3'"
                            :placeholder="'sutiajimumpung@gmail.com'"
                            :classes="'form-control inputs'"
                            :validationType="'email'"
                            :checkPattern="'email'"
                            ref="inputregular_email"
                        />
                        <!--<small id="alertEmail" class="form-text text-muted alertLabel"></small>-->
                        <ErrorMessage class="error" label="Email" :validation="$v.email"></ErrorMessage>
                    </div>

                    <div class="form-group mod">
                        <label class="form-label m-t-16" for="input-4">Kode Referral (Opsional)</label>
                        <input
                            class="form-control inputs"
                            type="input"
                            v-model="kodeReferral"
                            id="input-4"
                            :disabled="kodeReferral"
                        />
                        <small id="alertReferral" class="form-text text-muted alertLabel"></small>
                    </div>
                </form>
            </div>

            <div class="m-t-4 p-y-20 p-x-20 w-limit">
                <button class="btn smart-primary" @click="addacount" id="nextbutton">
                    <span
                        class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                        v-if="isClicked === true"
                    ></span>
                    <span id="txtBtn">Lanjut</span>
                </button>
            </div>
        </main>

        <!-- Modal -->
        <div class="modal fade" id="myModalclose" role="dialog">
            <div class="modal-dialog modal-lg bani-modal">
                <div class="modal-content">
                    <div class="modal-head w-limit">
                        <div class="modal-head--left"></div>
                        <div class="f-16 f-bold">Batalkan Pendaftaran</div>
                        <div class="modal-head--right" data-dismiss="modal">
                            <div class="icon-24 icon-x-blue"></div>
                        </div>
                    </div>
                    <div class="separator-line"></div>
                    <div class="modal-bodyy w-limit w-100 p-x-20">
                        <div class="m-t-16 f-16">
                            Apakah anda yakin ingin membatalkan proses daftar Smartlink Owner?
                        </div>
                        <div class="button-wrapper m-t-4 p-y-20 w-limit w-100">
                            <button type="button" class="btn smart-primary" data-dismiss="modal" @click="Cancel">
                                Ya, Batalkan
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="myModal" role="dialog">
            <div class="modal-dialog modal-lg bani-modal">
                <div class="modal-content">
                    <div class="modal-head w-limit">
                        <div class="modal-head--left"></div>
                        <div class="f-16 f-bold">Nama Perusahaan</div>
                        <div class="modal-head--right" data-dismiss="modal">
                            <div class="icon-24 icon-x-blue"></div>
                        </div>
                    </div>
                    <div class="separator-line"></div>
                    <div class="modal-bodyy w-limit w-100 p-x-20">
                        <div class="m-t-16 f-16">
                            Silahkan masukkan <b>nama perusahaan</b> sebagai identitas usaha anda (bukan nama outlet
                            atau laundry-an).
                        </div>
                        <form action="" class="m-t-16">
                            <div class="form-group mod">
                                <label for="input-4" class="form-label">Nama Perusahaan (Opsional)</label>
                                <InputRegular
                                    v-model="nama_usaha"
                                    :type="'text'"
                                    :id="'input-4'"
                                    :validationType="'alphanumeric'"
                                    :classes="'form-control'"
                                    :placeholder="'cth: CV Cuci Bersih'"
                                    ref="inputregular_nama_usaha"
                                />
                            </div>
                        </form>
                        <div class="button-wrapper m-t-4 p-y-20 w-limit w-100">
                            <button type="button" class="btn smart-primary" data-dismiss="modal">
                                Simpan Nama Perusahaan
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Select2 from "v-select2-component";
import InputRegular from "../../component-items/InputRegular";
import ErrorMessage from "@/component-items/ErrorMessage";
import { email, minLength, required } from "vuelidate/lib/validators";

export default {
    name: "FlowRegis1",
    components: {
        Select2,
        InputRegular,
        ErrorMessage,
    },
    mounted() {
        this.getkota();
        this.showAlertSuccess();
        $("#input-4").focus();
        $("div.alert.alert-success").fadeIn(3000);
        setTimeout(function() {
            $("#alertSuccess").addClass("fadeOutUp");
        }, 60000);

        $("#myModal").modal({
            backdrop: "static",
            keyboard: false,
        });
        if (localStorage.getItem("kode_afiliasi")) {
            this.kodeReferral = localStorage.getItem("kode_afiliasi");
        }
    },

    data() {
        return {
            nama: "",
            nama_usaha: "",
            email: "",
            selectedkota: "",
            optionskota: [],
            isClicked: false,

            kodeReferral: "",
        };
    },
    validations: {
        nama: {
            required,
            minLength: minLength(2),
        },
        selectedkota: {
            required,
        },
        email: {
            email,
        },
    },
    watch: {
        nama: function() {
            this.handleEmptyField();
        },
        selectedkota: function() {
            this.handleEmptyField();
        },
        // kodeReferral: function (e) {
        // 	this.kodeReferral = e.replace(/[^0-9]+/, '')
        // }
    },
    methods: {
        next() {
            this.$router.push("/successregis");
        },

        showAlertSuccess() {
            this.$toast.success("Nomor berhasil diverifikasi silahkan melanjutkan proses registrasi");
        },

        myChangeEvent(val) {
            this.myValue = val;
        },

        validateEmail(email) {
            var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },

        errorValidation() {
            if (this.$v.nama.$invalid || this.$v.selectedkota.$invalid) {
                this.$v.nama.$touch();
                this.$v.selectedkota.$touch();
                this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu");
                return true;
            }
            return false;
        },
        async addacount() {
            if (this.errorValidation()) {
                return;
            }
            var kota = this.selectedkota;
            var email = this.email;
            var namaPemilik = this.nama;
            var lenPassNama = namaPemilik.length;
            var lenEmail = email.length;
            var status = 0;
            if (lenPassNama <= 2) {
                status = 1;
                this.$refs.inputregular_nama.validateResult(false, "*Nama Pemilik tidak boleh kosong atau tidak valid");
            } else {
                this.$refs.inputregular_nama.validateResult(true);
            }

            if (kota !== "1") {
                $("#alertKota").removeClass("labeldanger");
                $("#alertKota").addClass("alertLabel");
                $(".select2-selection").prop("style", "border-color:#aaa");
            } else {
                status = 1;
                $("#alertKota").text("*Anda harus memilih kota domisili");
                $("#alertKota").removeClass("alertLabel");
                $("#alertKota").addClass("labeldanger");
                $(".select2-selection").prop("style", "border-color:red");
            }

            if (lenEmail >= 1) {
                if (!this.$refs.inputregular_email.validatePattern("email")) {
                    status = 1;
                }
            } else {
                this.$refs.inputregular_email.validateResult(true);
            }

            if (status === 0) {
                this.isClicked = true;
                $("#txtBtn").hide();
                var telp = localStorage.getItem("telp");
                try {
                    const dataregist = new FormData();
                    dataregist.append("nama", this.nama);
                    dataregist.append("kota", this.selectedkota);
                    dataregist.append("nama_usaha", this.nama_usaha);
                    dataregist.append("email", this.email);
                    dataregist.append("telp", telp);
                    dataregist.append("kode", this.kodeReferral);
                    const res = await this.$axios.post(this.$baseurl + "/auth/tambah_owner", dataregist);
                    if (res.data.status === true) {
                        localStorage.setItem("super_owner_key", res.data.data.superowner_key);
                        this.signIn(res.data.data.idowner);
                    } else {
                        this.$toast.error(res.data.msg);

                        this.isClicked = false;
                        $("#txtBtn").show();
                    }
                } catch (e) {
                    this.$catch_error_response(e);

                    this.isClicked = false;
                    $("#txtBtn").show();
                }
            }
        },
        async signIn(key) {
            try {
                var telp = localStorage.getItem("telp");
                var super_owner_key = localStorage.getItem("super_owner_key");
                const dataForm = new FormData();
                const appUserAgent = navigator.userAgent;
                dataForm.append("user_agent", appUserAgent);
                dataForm.append("idowner", key);
                dataForm.append("telp", telp);
                dataForm.append("super_owner_key", super_owner_key);
                const res = await this.$axios.post(this.$baseurl + "/auth/subakunsign", dataForm);
                if (res.status === 200) {
                    localStorage.setItem("token", res.data.data.token);
                    localStorage.setItem("idowner", res.data.data.idowner);
                    localStorage.removeItem("super_owner_key");
                    this.$router.push("/successregis");
                }
            } catch (e) {
                this.$catch_error_response(e);

                this.isClicked = false;
            }
        },
        async getkota() {
            try {
                const response = await this.$axios.get(this.$baseurl + "/masterData/meta/kota_meta");
                if (response.status === 200) {
                    var rawkota = response.data.data;
                    this.optionskota.push({
                        id: "",
                        text: "Pilih Kota",
                    });
                    for (var i = 0; i < rawkota.length; i++) {
                        this.optionskota.push({
                            id: rawkota[i].id,
                            text: rawkota[i].nama,
                        });
                    }
                }
            } catch (e) {
                this.$catch_error_response(e);
            }
        },

        Cancel() {
            this.$router.push("/startscreen");
        },
        handleEmptyField() {
            return;
            if (this.selectedkota === "1" || this.nama === "") {
                $("#nextbutton").prop("disabled", true);
            } else {
                $("#nextbutton").prop("disabled", false);
            }
        },
    },
};
</script>

<style scoped>
.test-select {
    margin-bottom: 12px;
}

.alertLabel {
    display: none;
}

.labeldanger {
    /*margin-top: -10px !important;*/
    color: red !important;
    margin-bottom: 15px !important;
    font-size: 13px;
}

.inputAlertDanger {
    border-color: red !important;
}

.set-text {
    font-weight: normal;
    font-size: 16px;
    line-height: 140%;
    letter-spacing: -0.02em;
    color: #333333;
}
</style>
